<h2 class="mb-5">{{ 'COMMON.PROCESSES' | translate }}</h2>

<div class="card mb-4 border-0 shadow-sm">
  <div class="card-header bg-white pt-4 border-bottom-0">
    <h5>{{ 'CANDIDATES.SEARCHFILTERS' | translate }}</h5>
  </div>

  <div class="card-body">
    <form [formGroup]="processSearchForm" (ngSubmit)="onSubmit()">
      <div class="form-row">
        <div class="form-group col-4">
          <label for="processName">{{ 'PROCESSES.PROCESSNAME' | translate }}</label>
          <input type="text" class="form-control" id="processName" formControlName="processName">
          <small id="processNameHelp" class="form-text text-muted" hidden>error</small>
        </div>

        <div class="form-group col-3">
          <label>&nbsp;</label>
          <button type="submit" class="btn btn-primary form-control"><i class="fa fa-search"></i>
            {{ 'COMMON.SEARCH' | translate }}</button>
        </div>
      </div>
    </form>
  </div>
</div>

<ct-datatable [items$]="processes$" (reload)="searchProcess($event.page, processSearchForm.get('processName').value)" class="datatable">
  <thead>
    <tr>
      <th colspan="1" id="results">{{ 'CANDIDATES.ALLRESULTS' | translate }} ({{ (processes$ | async)?.total || 0 }})
      </th>
      <th colspan="2"></th>
      <th colspan="1" id="actions">
        <div ngbDropdown placement="bottom-right">
          <div ngbDropdownToggle> {{'CONSULTANT.ACTIONS' | translate}} </div>
          <div ngbDropdownMenu>
            <button ngbDropdownItem routerLink="/consultant/processes/create">{{'PROCESSES.ADDPROCESS' | translate}}</button>
          </div>
        </div>
      </th>
    </tr>
  </thead>
  <thead>
    <tr>
      <th>{{'COMMON.NAME' | translate}}</th>
      <th>{{'COMMON.TYPE' | translate | titlecase}}</th>
      <th>{{'COMMON.CANDIDATES' | translate}}</th>
      <th>{{'CONSULTANT.ACTIONS' | translate}}</th>
    </tr>
  </thead>
  <tbody class="bg-white">
    <tr *ngFor="let process of (processes$ | async)?.data; index as i" [ngClass]="{disabledRow: (process.id == 1 || process.isLocked)}">
      <td *ngIf="process.isLocked">{{ process?.name }}</td>
      <td *ngIf="!process.isLocked" class="cursor-pointer" [routerLink]="['/consultant/processes/show', process.id]">{{ process?.name }}</td>
      <td>{{ process.jobtypeId ? (utilsService.jobtypeFromJobtypeId(process.jobtypeId)?.name | titlecase) : '-' }}</td>
      <td>{{ process.invitationsCount }}</td>
      <td>
        <i class="fa fa-edit" [routerLink]="(process.id == 1 || process.isLocked) ? null : ['/consultant/processes/edit', process.id]" [ngbTooltip]="((process.id == 1 || process.isLocked) ? 'TOOLTIP.UNABLEEDIT' :'TOOLTIP.EDIT') | translate"></i>
        <i class="fa fa-trash" (click)="(process.id == 1 || process.isLocked) ? null :showModalDeleteProcess(process)" [ngbTooltip]="((process.id == 1 || process.isLocked) ? 'TOOLTIP.UNABLEDELETE' :'TOOLTIP.DELETE') | translate"></i>
      </td>
    </tr>
    <tr *ngIf="!(processes$ | async)?.data?.length">
      <td colspan="4" class="text-center">{{ 'CANDIDATES.NORESULTS' | translate }}</td>
    </tr>
  </tbody>
</ct-datatable>


<ng-template #content let-modal>
  <div class="modal-header border-bottom-0">
    <h5 class="modal-title">{{ 'COMMON.DELETE' | translate }}</h5>
    <div id="closeModal">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>&nbsp;
      </button>
    </div>
  </div>

  <div class="modal-body">
    <p>¿Realmente quieres borrar este proceso?</p>
  </div>
  <div class="modal-footer justify-content-center">
    <button type="button" class="btn btn-secondary"
      (click)="modal.dismiss('cancel click')">{{ 'COMMON.CANCEL' | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="deleteProcess()">OK</button>
  </div>
</ng-template>
